<script setup lang="ts">
import { computed, useAttrs } from 'vue';

defineOptions({ inheritAttrs: false, name: 'EGS_RadioButton' });
const props = withDefaults(defineProps<{ modelValue?: unknown; value?: unknown; disabled?: boolean; inputId?: string; name?: string }>(), { disabled: false });
const emit = defineEmits<{ 'update:modelValue': [value: unknown] }>();
const attrs = useAttrs();
const checked = computed(() => Object.is(props.modelValue, props.value));
const inputIdentity = computed(() => {
	const values: Record<string, string> = {};
	if (props.inputId) values['id'] = props.inputId;
	if (props.name) values['name'] = props.name;
	return values;
});
</script>

<template>
	<label :class="['relative inline-flex h-5 w-5 shrink-0 align-middle', disabled ? 'opacity-60' : '', attrs['class']]">
		<input v-bind="{ ...attrs, ...inputIdentity }" type="radio" class="peer absolute inset-0 z-10 m-0 h-full w-full cursor-pointer opacity-0" :checked="checked" :disabled="disabled" @change="emit('update:modelValue', value)" />
		<span :class="['flex h-5 w-5 items-center justify-center rounded-full border bg-[var(--egs-content-background)] transition peer-focus-visible:ring-2 peer-focus-visible:ring-primary-300', checked ? 'border-primary-600' : 'border-surface']">
			<span :class="['h-2.5 w-2.5 rounded-full', checked ? 'bg-primary-600' : 'bg-transparent']"></span>
		</span>
	</label>
</template>
